<template>
  <div id="step-background"  v-if="stepsShow">
    <lk-steps :current="currentStep">
      <lk-step
        v-for="(item, index) in stepList"
        :title="item.title"
        :content="item.content"
        :status="item.status"
        :class="item.status==='error'? 'ivu-steps-status-finish':''"
        :key="index"/>
    </lk-steps>
  </div>
</template>
<script>
import workflow from '../services/workflow';

export default {
  name: 'ApprovalFlow',
  props: {
    workNo: {
      type: String,
      default: '',
    },
    finishHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentStep: 0,
      stepList: [],
      finalFinish: false,
    };
  },
  computed: {
    stepsShow() {
      if (!this.workNo) {
        return false;
      }
      // 审批流结束，并且开启了结束隐藏
      if (this.finalFinish && this.finishHide) {
        return false;
      }
      return true;
    },
  },
  methods: {
    getData() {
      const workNo = this.workNo;
      if (!workNo) return;
      workflow.approveSteps({ workNo }).then((res) => {
        if (res.data.status == 200) {
          const nodeList = res.data.data.nodeVoList;
          this.currentStep = res.data.data.currentNode;
          // this.currentStep = 2;
          // debugger;
          const value = {};
          value.remark = res.data.data.remark;
          value.bizExtraVos = res.data.data.bizExtraVos;
          this.$emit('attachmentValue', value);
          this.$emit('handleOver', this.currentStep === nodeList.length - 1);
          this.$emit('showQualityOpinions', res.data.data.showQualityOpinions);
          this.stepList = nodeList.map((item, index) => {
            const temp = {
              title: item.name,
              status: item.status,
            };
            if (index == (nodeList.length - 1)) {
              if (item.status == 'finish') {
                this.finalFinish = true;
                console.log(this.finalFinish);
              }
            }
            if (item.roleName || item.userName) {
              const userName = `${item.userName || ''}`;
              const roleName = `(${item.roleName})`;
              const idea = item.idea
                ? `: ${item.idea}`
                : '';
              temp.content = userName + roleName + idea;
            } else {
              temp.content = '';
            }
            return temp;
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    workNo() {
      this.getData();
    },
  },
};
</script>
